import type { RouteLocationNormalized, RouteRecordRaw } from "vue-router";
import type { Acl, User } from "vue-simple-acl/types/acl";
import { BREADCRUMBS } from "~/core/constants/breadcrumbs";
import { ACLRoles } from "~/core/models/ACLRoles.enum";
import {
  PATH_PARAMETERS_INTERFACES,
  PATH_PARAMETERS_INTERFACES_DATA_SHARING,
  PATH_PARAMETERS_INTERFACES_DATA_SHARING_ID,
  PATH_PARAMETERS_INTERFACES_THIRD_PARTY,
  PATH_PARAMETERS_INTERFACES_THIRD_PARTY_ID,
} from "~/modules/interface/constants";
import { LicenseFeatureName } from "~/modules/license/models/LicenseFeatureName.enum";
import { useLicenseStore } from "~/modules/license/stores/useLicenseStore";

const routes: RouteRecordRaw[] = [
  {
    path: PATH_PARAMETERS_INTERFACES,
    redirect: PATH_PARAMETERS_INTERFACES_THIRD_PARTY,
  },
  {
    path: PATH_PARAMETERS_INTERFACES_THIRD_PARTY,
    component: () => import("~/modules/interface/views/InterfacePage.vue"),
    meta: {
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: Acl<User>["can"],
      ) =>
        can(ACLRoles.CAN_READ_APPLICATION) &&
        useLicenseStore().isLicenseFeatureEnabled(
          LicenseFeatureName.INTERFACES_THIRD_PARTY,
        ),
      breadcrumb: BREADCRUMBS.INTERFACE,
    },
  },
  {
    path: PATH_PARAMETERS_INTERFACES_THIRD_PARTY_ID,
    component: () => import("~/modules/interface/views/InterfacePage.vue"),
    meta: {
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: Acl<User>["can"],
      ) =>
        can(ACLRoles.CAN_READ_APPLICATION) &&
        useLicenseStore().isLicenseFeatureEnabled(
          LicenseFeatureName.INTERFACES_THIRD_PARTY,
        ),
      breadcrumb: BREADCRUMBS.INTERFACE,
    },
  },
  {
    path: PATH_PARAMETERS_INTERFACES_DATA_SHARING,
    component: () => import("~/modules/interface/views/InterfacePage.vue"),
    meta: {
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: Acl<User>["can"],
      ) =>
        can(ACLRoles.CAN_READ_APPLICATION) &&
        useLicenseStore().isLicenseFeatureEnabled(
          LicenseFeatureName.INTERFACES_THIRD_PARTY,
        ),
      breadcrumb: BREADCRUMBS.INTERFACE,
    },
  },
  {
    path: PATH_PARAMETERS_INTERFACES_DATA_SHARING_ID,
    component: () => import("~/modules/interface/views/InterfacePage.vue"),
    meta: {
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: Acl<User>["can"],
      ) =>
        can(ACLRoles.CAN_READ_APPLICATION) &&
        useLicenseStore().isLicenseFeatureEnabled(
          LicenseFeatureName.INTERFACES_THIRD_PARTY,
        ),
      breadcrumb: BREADCRUMBS.INTERFACE,
    },
  },
];

export default routes;
